import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { factValue, showValue } from "@/lib/onb";

const FACTS = [["volumes", "Volume"], ["time_spent", "Time spent today"], ["human_required", "Must stay human"], ["tools", "Tools"], ["pain", "Biggest pain"], ["goal", "Goal"]];

export const TailoredChip = ({ profile }) => {
  const c = profile?.company || {};
  const bits = [["Offer", factValue(c.offer)], ["ICP", factValue(c.icp)]].filter(([, v]) => v);
  if (!bits.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-xs text-muted-foreground max-w-3xl" data-testid="sky-tailored-chip">
      <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#00E5FF]"><Sparkles className="w-3 h-3" />Tailored from your answers</span>
      {bits.map(([k, v]) => <span key={k}><span className="text-foreground">{k}:</span> {showValue(v)}</span>)}
    </div>
  );
};

const Flow = ({ steps, hex }) => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid="tailored-process">
    {steps.map((s, i) => (
      <span key={i} className="flex items-center gap-1.5">
        <span className="px-2.5 py-1 rounded-full border text-[11px]" style={{ borderColor: `${hex}55` }}>{s}</span>
        {i < steps.length - 1 && <ArrowRight className="w-3 h-3 text-muted-foreground" />}
      </span>
    ))}
  </div>
);

export const TailoredBrief = ({ d, profile, list, tot }) => {
  const f = profile?.departments?.[d.slug];
  if (!tot.tailored && !f) return null;
  const proc = factValue(f?.process);
  const steps = Array.isArray(proc) ? proc : proc ? [String(proc)] : [];
  const facts = FACTS.map(([k, l]) => [l, factValue(f?.[k])]).filter(([, v]) => v);
  const off = list.filter((a) => a.tailored && !a.tailored.enabled).length;
  return (
    <section className="rounded-xl border p-5 grid lg:grid-cols-[1.4fr_1fr] gap-5 mh-rise" style={{ borderColor: `${d.hex}30`, background: `${d.hex}08` }} data-testid="dept-tailored-brief">
      <div className="space-y-3 min-w-0">
        <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.24em] text-[#00E5FF]"><Sparkles className="w-3 h-3" />Tailored from your {d.name} interview</div>
        {steps.length ? <><div className="text-xs text-muted-foreground">Your flow today</div><Flow steps={steps} hex={d.hex} /></>
          : <p className="text-sm text-muted-foreground">No interview yet, so these roles use the standard atlas. <Link to="/build" className="underline text-foreground" data-testid="tailored-brief-build">Answer the {d.name} questions</Link> to tailor them.</p>}
        <p className="text-xs text-muted-foreground" data-testid="tailored-brief-roles">{tot.active} roles switched on for you{off ? `, ${off} faded as not relevant` : ""}. Circle size shows projected value.</p>
      </div>
      {facts.length > 0 && (
        <dl className="grid grid-cols-2 gap-3 text-xs" data-testid="tailored-facts">
          {facts.map(([l, v]) => <div key={l}><dt className="font-mono text-[9px] uppercase tracking-[0.2em] text-muted-foreground">{l}</dt><dd className="mt-1">{showValue(v)}</dd></div>)}
        </dl>
      )}
    </section>
  );
};
